/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Action, State } from '../redux';

const initialState: State['tasks'] = {
  current: null as any, // TODO: figure out pattern of asserting null values as NonNullable in a post load state
};

export function tasksReducer(state = initialState, action: Action) {
  switch (action.type) {
    case 'SET_CURRENT_TASK':
      return { ...state, current: action.payload };
    default:
      return state;
  }
}
